module.exports = __webpack_public_path__ + "img/maids.04727879.png";